var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.audio)?_c('time',{staticClass:"duration",domProps:{"innerHTML":_vm._s(_vm.duration ? _vm.formatMSS(_vm.duration): " ")}},[_c('audio',{ref:"file",attrs:{"src":_vm.audio,"preload":"metadata"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }